import consoleLog from "@/utils/consoleLog";
import IcpFooter from "@/views/IcpFooter.vue";

export default {
    name: 'HomePage',
    components: {IcpFooter},
    data() {
        return {
            homeMenus: [
                {
                    "title": "我的应用",
                    "list": [{title: '应用列表', path: "/appListPage"}]
                },
                {
                    "title": "设备管理",
                    "list": [{title: '设备列表', path: "/deViceListPage"},
                        {title: '设备统计', path: "/deviceStatisticsPage"}]
                },
                {
                    "title": "消息管理",
                    "list": [{title: '消息列表', path: "/messageListPage"}]
                },
                {
                    "title": "日志管理",
                    "list": [
                        {title: '历史在线日志', path: "/historyOnlineLogPage"},
                        {title: '本地回捞日志', path: "/localLogListPage"},
                        {title: '本地日志解密', path: "/logDecryptPage"}]
                }

            ],
            userInfo: {}
        }
    },
    methods: {
        logout() {
            window.localStorage.removeItem("userInfo")
            window.doPush(this, "/loginPage")
        },
        //Menu点击事件
        itemOnclick(item, index) {
            consoleLog.log("itemOnclick item:" + item + ",index:" + index)
            window.doPush(this, item.path)
        },
        userClick() {
            window.doOpen(this, "/userInfoPage")
        },
    },
    created() {
        const userInfoStr = window.localStorage.getItem("userInfo")
        if (userInfoStr) {
            this.userInfo = JSON.parse(userInfoStr)
        } else {
            window.replace(this, "/loginPage")
        }
    }
}